export enum ClientSettingsField {    
    PALLET_PASSPORT_TEMPLATE = 'palletPassportTemplate',
}